import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'dash-rupturas',
  templateUrl: './rupturas.component.html',
  styleUrls: ['./rupturas.component.scss']
})
export class RupturasComponent implements OnInit {

  private subscription: Subscription;
  public loading: boolean;
  public rupturasStat: any = null;
  public dateSetup: any;

  constructor(private _orderService: OrderService,
    private _stateService: StatesService) { 
    this.loading = true;
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe(res => {
      this.dateSetup = res;
      this._orderService.ordersMetas(this.dateSetup.start_date, this.dateSetup.end_date).subscribe(data => {
        this._stateService.changeMetas(data);
        this._stateService.currentMetas.subscribe(res => {
          this.rupturasStat = res;
          this.loading = false;
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
